import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Testimonials() {
  const { testimonials } = useSite();

  return (
    <section data-testid="testimonials-section" className="section-padding bg-[#f5f7fa] relative overflow-hidden">
      <div className="dc-container relative">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-dc-primary">Depoimentos</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-dc-text mt-3 mb-4">
            Empresas que confiam na DeskcodeBR
          </h2>
          <p className="text-base md:text-lg text-slate-600">Cada parceria é uma evolução tecnológica entregue.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              data-testid={`testimonial-${t.id}`}
              className="bg-white rounded-2xl p-7 border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all relative"
            >
              <Quote className="w-8 h-8 text-dc-primary/15 absolute top-5 right-5" />
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-sm text-slate-700 leading-relaxed mb-6 min-h-[100px]">"{t.content}"</p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-dc-primary to-dc-accent text-white flex items-center justify-center font-heading font-bold">
                  {t.name?.[0]}
                </div>
                <div>
                  <div className="font-heading font-semibold text-dc-text text-sm">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role}{t.company && ` • ${t.company}`}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
